import React from 'react';
import '../styles/Cancel.css';

export default function Cancel() {
  return (
    <div className="cancel-container">
      <div className="cancel-card">
        <div className="cancel-icon">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
            <circle cx="32" cy="32" r="32" fill="#f44336" />
            <path
              d="M24 24L40 40M40 24L24 40"
              stroke="white"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h1 className="cancel-title">Payment Cancelled</h1>
        <p className="cancel-message">
          Your payment was cancelled. No charges have been made to your account.
        </p>

        <div className="cancel-note">
          <p>
            If this was a mistake, you can try again or contact our support team
            for assistance.
          </p>
        </div>
      </div>
    </div>
  );
}

Cancel.propTypes = {};
